var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.31 13.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ccc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "popup_banco"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.54,11.08c-3.05,0-5.54-2.49-5.54-5.54S2.49,0,5.54,0s5.54,2.49,5.54,5.54-2.49,5.54-5.54,5.54ZM5.54.38C2.69.38.38,2.69.38,5.54s2.32,5.16,5.16,5.16,5.16-2.32,5.16-5.16S8.39.38,5.54.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.64,9.89c-1.17,0-2.33-.48-3.17-1.42-1.56-1.75-1.4-4.43.34-5.99.08-.07.2-.06.27.02.07.08.06.2-.02.27-1.59,1.42-1.73,3.87-.31,5.46,1.42,1.59,3.87,1.73,5.46.31.08-.07.2-.06.27.02.07.08.06.2-.02.27-.81.72-1.82,1.08-2.82,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,13.43c-.26,0-.49-.09-.66-.27l-2.82-2.88c-.07-.07-.07-.19,0-.27.07-.07.19-.07.27,0l2.82,2.88c.11.11.27.17.47.15.2-.02.4-.12.57-.28.16-.16.27-.36.29-.56.02-.19-.03-.35-.14-.47l-2.82-2.88c-.07-.07-.07-.19,0-.27.07-.07.19-.07.27,0l2.82,2.88c.19.2.28.47.24.77-.03.29-.18.57-.4.79s-.51.36-.79.38c-.04,0-.07,0-.11,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c3e62b14792bebe05219dd0892ed0a96.svg";
export { ForwardRef as ReactComponent };